import React from "react";

export const FontAwesomeIconData = [
    {id: 'fas fa-address-book', name: 'address-book', value: 'fas fa-address-book'},
    {id: 'fas fa-address-card', name: 'address-card', value: 'fas fa-address-card'},
    {id: 'fas fa-adjust', name: 'adjust', value: 'fas fa-adjust'},
    {id: 'fas fa-align-center', name: 'align-center', value: 'fas fa-align-center'},
    {id: 'fas fa-align-justify', name: 'align-justify', value: 'fas fa-align-justify'},
    {id: 'fas fa-align-left', name: 'align-left', value: 'fas fa-align-left'},
    {id: 'fas fa-align-right', name: 'align-right', value: 'fas fa-align-right'},
    {id: 'fas fa-allergies', name: 'allergies', value: 'fas fa-allergies'},
    {id: 'fas fa-ambulance', name: 'ambulance', value: 'fas fa-ambulance'},
    {
        id: 'fas fa-american-sign-language-interpreting',
        name: 'american-sign-language-interpreting',
        value: 'fas fa-american-sign-language-interpreting'
    },
    {id: 'fas fa-anchor', name: 'anchor', value: 'fas fa-anchor'},
    {id: 'fas fa-angle-double-down', name: 'angle-double-down', value: 'fas fa-angle-double-down'},
    {id: 'fas fa-angle-double-left', name: 'angle-double-left', value: 'fas fa-angle-double-left'},
    {id: 'fas fa-angle-double-right', name: 'angle-double-right', value: 'fas fa-angle-double-right'},
    {id: 'fas fa-angle-double-up', name: 'angle-double-up', value: 'fas fa-angle-double-up'},
    {id: 'fas fa-angle-down', name: 'angle-down', value: 'fas fa-angle-down'},
    {id: 'fas fa-angle-left', name: 'angle-left', value: 'fas fa-angle-left'},
    {id: 'fas fa-angle-right', name: 'angle-right', value: 'fas fa-angle-right'},
    {id: 'fas fa-angle-up', name: 'angle-up', value: 'fas fa-angle-up'},
    {id: 'fas fa-archive', name: 'archive', value: 'fas fa-archive'},
    {id: 'fas fa-arrow-alt-circle-down', name: 'arrow-alt-circle-down', value: 'fas fa-arrow-alt-circle-down'},
    {id: 'fas fa-arrow-alt-circle-left', name: 'arrow-alt-circle-left', value: 'fas fa-arrow-alt-circle-left'},
    {id: 'fas fa-arrow-alt-circle-right', name: 'arrow-alt-circle-right', value: 'fas fa-arrow-alt-circle-right'},
    {id: 'fas fa-arrow-alt-circle-up', name: 'arrow-alt-circle-up', value: 'fas fa-arrow-alt-circle-up'},
    {id: 'fas fa-arrow-circle-down', name: 'arrow-circle-down', value: 'fas fa-arrow-circle-down'},
    {id: 'fas fa-arrow-circle-left', name: 'arrow-circle-left', value: 'fas fa-arrow-circle-left'},
    {id: 'fas fa-arrow-circle-right', name: 'arrow-circle-right', value: 'fas fa-arrow-circle-right'},
    {id: 'fas fa-arrow-circle-up', name: 'arrow-circle-up', value: 'fas fa-arrow-circle-up'},
    {id: 'fas fa-arrow-down', name: 'arrow-down', value: 'fas fa-arrow-down'},
    {id: 'fas fa-arrow-left', name: 'arrow-left', value: 'fas fa-arrow-left'},
    {id: 'fas fa-arrow-right', name: 'arrow-right', value: 'fas fa-arrow-right'},
    {id: 'fas fa-arrow-up', name: 'arrow-up', value: 'fas fa-arrow-up'},
    {id: 'fas fa-arrows-alt', name: 'arrows-alt', value: 'fas fa-arrows-alt'},
    {id: 'fas fa-arrows-alt-h', name: 'arrows-alt-h', value: 'fas fa-arrows-alt-h'},
    {id: 'fas fa-arrows-alt-v', name: 'arrows-alt-v', value: 'fas fa-arrows-alt-v'},
    {
        id: 'fas fa-assistive-listening-systems',
        name: 'assistive-listening-systems',
        value: 'fas fa-assistive-listening-systems'
    },
    {id: 'fas fa-asterisk', name: 'asterisk', value: 'fas fa-asterisk'},
    {id: 'fas fa-at', name: 'at', value: 'fas fa-at'},
    {id: 'fas fa-audio-tion', name: 'audio-tion', value: 'fas fa-audio-tion'},
    {id: 'fas fa-backward', name: 'backward', value: 'fas fa-backward'},
    {id: 'fas fa-balance-scale', name: 'balance-scale', value: 'fas fa-balance-scale'},
    {id: 'fas fa-ban', name: 'ban', value: 'fas fa-ban'},
    {id: 'fas fa-band-aid', name: 'band-aid', value: 'fas fa-band-aid'},
    {id: 'fas fa-barcode', name: 'barcode', value: 'fas fa-barcode'},
    {id: 'fas fa-bars', name: 'bars', value: 'fas fa-bars'},
    {id: 'fas fa-baseball-ball', name: 'baseball-ball', value: 'fas fa-baseball-ball'},
    {id: 'fas fa-basketba', name: 'basketba', value: 'fas fa-basketba'},
    {id: 'fas fa-bath', name: 'bath', value: 'fas fa-bath'},
    {id: 'fas fa-battery-empty', name: 'battery-empty', value: 'fas fa-battery-empty'},
    {id: 'fas fa-battery-full', name: 'battery-full', value: 'fas fa-battery-full'},
    {id: 'fas fa-battery-half', name: 'battery-half', value: 'fas fa-battery-half'},
    {id: 'fas fa-battery-quarter', name: 'battery-quarter', value: 'fas fa-battery-quarter'},
    {id: 'fas fa-battery-three-quarters', name: 'battery-three-quarters', value: 'fas fa-battery-three-quarters'},
    {id: 'fas fa-bed', name: 'bed', value: 'fas fa-bed'},
    {id: 'fas fa-beer', name: 'beer', value: 'fas fa-beer'},
    {id: 'fas fa-bell', name: 'bell', value: 'fas fa-bell'},
    {id: 'fas fa-bell-slash', name: 'bell-slash', value: 'fas fa-bell-slash'},
    {id: 'fas fa-bicycle', name: 'bicycle', value: 'fas fa-bicycle'},
    {id: 'fas fa-binoculars', name: 'binoculars', value: 'fas fa-binoculars'},
    {id: 'fas fa-birthday-cake', name: 'birthday-cake', value: 'fas fa-birthday-cake'},
    {id: 'fas fa-blind', name: 'blind', value: 'fas fa-blind'},
    {id: 'fas fa-bold', name: 'bold', value: 'fas fa-bold'},
    {id: 'fas fa-bolt', name: 'bolt', value: 'fas fa-bolt'},
    {id: 'fas fa-bomb', name: 'bomb', value: 'fas fa-bomb'},
    {id: 'fas fa-book', name: 'book', value: 'fas fa-book'},
    {id: 'fas fa-bookmark', name: 'bookmark', value: 'fas fa-bookmark'},
    {id: 'fas fa-bowling-ball', name: 'bowling-ball', value: 'fas fa-bowling-ball'},
    {id: 'fas fa-box', name: 'box', value: 'fas fa-box'},
    {id: 'fas fa-box-open', name: 'box-open', value: 'fas fa-box-open'},
    {id: 'fas fa-boxes', name: 'boxes', value: 'fas fa-boxes'},
    {id: 'fas fa-braille', name: 'braille', value: 'fas fa-braille'},
    {id: 'fas fa-briefcase', name: 'briefcase', value: 'fas fa-briefcase'},
    {id: 'fas fa-briefcical', name: 'briefcical', value: 'fas fa-briefcical'},
    {id: 'fas fa-bug', name: 'bug', value: 'fas fa-bug'},
    {id: 'fas fa-building', name: 'building', value: 'fas fa-building'},
    {id: 'fas fa-bullhorn', name: 'bullhorn', value: 'fas fa-bullhorn'},
    {id: 'fas fa-bullseye', name: 'bullseye', value: 'fas fa-bullseye'},
    {id: 'fas fa-burn', name: 'burn', value: 'fas fa-burn'},
    {id: 'fas fa-bus', name: 'bus', value: 'fas fa-bus'},
    {id: 'fas fa-calculator', name: 'calculator', value: 'fas fa-calculator'},
    {id: 'fas fa-calendar', name: 'calendar', value: 'fas fa-calendar'},
    {id: 'fas fa-calendar-alt', name: 'calendar-alt', value: 'fas fa-calendar-alt'},
    {id: 'fas fa-calendar-check', name: 'calendar-check', value: 'fas fa-calendar-check'},
    {id: 'fas fa-calendar-minus', name: 'calendar-minus', value: 'fas fa-calendar-minus'},
    {id: 'fas fa-calendar-plus', name: 'calendar-plus', value: 'fas fa-calendar-plus'},
    {id: 'fas fa-calendar-times', name: 'calendar-times', value: 'fas fa-calendar-times'},
    {id: 'fas fa-camera', name: 'camera', value: 'fas fa-camera'},
    {id: 'fas fa-camera-retro', name: 'camera-retro', value: 'fas fa-camera-retro'},
    {id: 'fas fa-capsules', name: 'capsules', value: 'fas fa-capsules'},
    {id: 'fas fa-car', name: 'car', value: 'fas fa-car'},
    {id: 'fas fa-caret-down', name: 'caret-down', value: 'fas fa-caret-down'},
    {id: 'fas fa-caret-left', name: 'caret-left', value: 'fas fa-caret-left'},
    {id: 'fas fa-caret-right', name: 'caret-right', value: 'fas fa-caret-right'},
    {id: 'fas fa-caret-down', name: 'caret-down', value: 'fas fa-caret-down'},
    {id: 'fas fa-caret-left', name: 'caret-left', value: 'fas fa-caret-left'},
    {id: 'fas fa-caret-right', name: 'caret-right', value: 'fas fa-caret-right'},
    {id: 'fas fa-caret-sq', name: 'caret-sq', value: 'fas fa-caret-sq'},
    {id: 'fas fa-caret-up', name: 'caret-up', value: 'fas fa-caret-up'},
    {id: 'fas fa-cart-arr', name: 'cart-arr', value: 'fas fa-cart-arr'},
    {id: 'fas fa-cart-plus', name: 'cart-plus', value: 'fas fa-cart-plus'},
    {id: 'fas fa-certificate', name: 'certificate', value: 'fas fa-certificate'},
    {id: 'fas fa-chart-area', name: 'chart-area', value: 'fas fa-chart-area'},
    {id: 'fas fa-chart-bar', name: 'chart-bar', value: 'fas fa-chart-bar'},
    {id: 'fas fa-chart-line', name: 'chart-line', value: 'fas fa-chart-line'},
    {id: 'fas fa-chart-pie', name: 'chart-pie', value: 'fas fa-chart-pie'},
    {id: 'fas fa-check', name: 'check', value: 'fas fa-check'},
    {id: 'fas fa-check-circle', name: 'check-circle', value: 'fas fa-check-circle'},
    {id: 'fas fa-check-square', name: 'check-square', value: 'fas fa-check-square'},
    {id: 'fas fa-chess', name: 'chess', value: 'fas fa-chess'},
    {id: 'fas fa-chess-bishop', name: 'chess-bishop', value: 'fas fa-chess-bishop'},
    {id: 'fas fa-chess-board', name: 'chess-board', value: 'fas fa-chess-board'},
    {id: 'fas fa-chess-king', name: 'chess-king', value: 'fas fa-chess-king'},
    {id: 'fas fa-chess-knight', name: 'chess-knight', value: 'fas fa-chess-knight'},
    {id: 'fas fa-chess-pawn', name: 'chess-pawn', value: 'fas fa-chess-pawn'},
    {id: 'fas fa-chess-queen', name: 'chess-queen', value: 'fas fa-chess-queen'},
    {id: 'fas fa-chess-rook', name: 'chess-rook', value: 'fas fa-chess-rook'},
    {id: 'fas fa-chevron-circle-down', name: 'chevron-circle-down', value: 'fas fa-chevron-circle-down'},
    {id: 'fas fa-chevron-circle-left', name: 'chevron-circle-left', value: 'fas fa-chevron-circle-left'},
    {id: 'fas fa-chevron-circle-right', name: 'chevron-circle-right', value: 'fas fa-chevron-circle-right'},
    {id: 'fas fa-chevroe-up', name: 'chevroe-up', value: 'fas fa-chevroe-up'},
    {id: 'fas fa-chevron-down', name: 'chevron-down', value: 'fas fa-chevron-down'},
    {id: 'fas fa-chevron-left', name: 'chevron-left', value: 'fas fa-chevron-left'},
    {id: 'fas fa-chevron-right', name: 'chevron-right', value: 'fas fa-chevron-right'},
    {id: 'fas fa-chevron-up', name: 'chevron-up', value: 'fas fa-chevron-up'},
    {id: 'fas fa-child', name: 'child', value: 'fas fa-child'},
    {id: 'fas fa-circle', name: 'circle', value: 'fas fa-circle'},
    {id: 'fas fa-circle-notch', name: 'circle-notch', value: 'fas fa-circle-notch'},
    {id: 'fas fa-clipboard', name: 'clipboard', value: 'fas fa-clipboard'},
    {id: 'fas fa-clipboard-check', name: 'clipboard-check', value: 'fas fa-clipboard-check'},
    {id: 'fas fa-clipboard-list', name: 'clipboard-list', value: 'fas fa-clipboard-list'},
    {id: 'fas fa-clock', name: 'clock', value: 'fas fa-clock'},
    {id: 'fas fa-clone', name: 'clone', value: 'fas fa-clone'},
    {id: 'fas fa-closedning', name: 'closedning', value: 'fas fa-closedning'},
    {id: 'fas fa-cloud', name: 'cloud', value: 'fas fa-cloud'},
    {id: 'fas fa-cloudad-alt', name: 'cloudad-alt', value: 'fas fa-cloudad-alt'},
    {id: 'fas fa-cloud-alt', name: 'cloud-alt', value: 'fas fa-cloud-alt'},
    {id: 'fas fa-code', name: 'code', value: 'fas fa-code'},
    {id: 'fas fa-code-branch', name: 'code-branch', value: 'fas fa-code-branch'},
    {id: 'fas fa-coffee', name: 'coffee', value: 'fas fa-coffee'},
    {id: 'fas fa-cog', name: 'cog', value: 'fas fa-cog'},
    {id: 'fas fa-cogs', name: 'cogs', value: 'fas fa-cogs'},
    {id: 'fas fa-columns', name: 'columns', value: 'fas fa-columns'},
    {id: 'fas fa-comment', name: 'comment', value: 'fas fa-comment'},
    {id: 'fas fa-comment-alt', name: 'comment-alt', value: 'fas fa-comment-alt'},
    {id: 'fas fa-comment-dots', name: 'comment-dots', value: 'fas fa-comment-dots'},
    {id: 'fas fa-comment-slash', name: 'comment-slash', value: 'fas fa-comment-slash'},
    {id: 'fas fa-comments', name: 'comments', value: 'fas fa-comments'},
    {id: 'fas fa-compass', name: 'compass', value: 'fas fa-compass'},
    {id: 'fas fa-compress', name: 'compress', value: 'fas fa-compress'},
    {id: 'fas fa-copy', name: 'copy', value: 'fas fa-copy'},
    {id: 'fas fa-copyright', name: 'copyright', value: 'fas fa-copyright'},
    {id: 'fas fa-couch', name: 'couch', value: 'fas fa-couch'},
    {id: 'fas fa-credit-card', name: 'credit-card', value: 'fas fa-credit-card'},
    {id: 'fas fa-crop', name: 'crop', value: 'fas fa-crop'},
    {id: 'fas fa-crosshairs', name: 'crosshairs', value: 'fas fa-crosshairs'},
    {id: 'fas fa-cube', name: 'cube', value: 'fas fa-cube'},
    {id: 'fas fa-cubes', name: 'cubes', value: 'fas fa-cubes'},
    {id: 'fas fa-cut', name: 'cut', value: 'fas fa-cut'},
    {id: 'fas fa-database', name: 'database', value: 'fas fa-database'},
    {id: 'fas fa-deaf', name: 'deaf', value: 'fas fa-deaf'},
    {id: 'fas fa-desktop', name: 'desktop', value: 'fas fa-desktop'},
    {id: 'fas fa-diagnoses', name: 'diagnoses', value: 'fas fa-diagnoses'},
    {id: 'fas fa-dna', name: 'dna', value: 'fas fa-dna'},
    {id: 'fas fa-dollar-sign', name: 'dollar-sign', value: 'fas fa-dollar-sign'},
    {id: 'fas fa-dolly', name: 'dolly', value: 'fas fa-dolly'},
    {id: 'fas fa-dolly-flatbed', name: 'dolly-flatbed', value: 'fas fa-dolly-flatbed'},
    {id: 'fas fa-donate', name: 'donate', value: 'fas fa-donate'},
    {id: 'fas fa-dot-circle', name: 'dot-circle', value: 'fas fa-dot-circle'},
    {id: 'fas fa-dove', name: 'dove', value: 'fas fa-dove'},
    {id: 'fas fa-download', name: 'download', value: 'fas fa-download'},
    {id: 'fas fa-edit', name: 'edit', value: 'fas fa-edit'},
    {id: 'fas fa-eject', name: 'eject', value: 'fas fa-eject'},
    {id: 'fas fa-ellipsis-h', name: 'ellipsis-h', value: 'fas fa-ellipsis-h'},
    {id: 'fas fa-ellipsis-v', name: 'ellipsis-v', value: 'fas fa-ellipsis-v'},
    {id: 'fas fa-envelope', name: 'envelope', value: 'fas fa-envelope'},
    {id: 'fas fa-envelope-open', name: 'envelope-open', value: 'fas fa-envelope-open'},
    {id: 'fas fa-envelope-square', name: 'envelope-square', value: 'fas fa-envelope-square'},
    {id: 'fas fa-eraser', name: 'eraser', value: 'fas fa-eraser'},
    {id: 'fas fa-euro-sign', name: 'euro-sign', value: 'fas fa-euro-sign'},
    {id: 'fas fa-exchange-alt', name: 'exchange-alt', value: 'fas fa-exchange-alt'},
    {id: 'fas fa-exclamation', name: 'exclamation', value: 'fas fa-exclamation'},
    {id: 'fas fa-exclamation-circle', name: 'exclamation-circle', value: 'fas fa-exclamation-circle'},
    {id: 'fas fa-exclamation-triangle', name: 'exclamation-triangle', value: 'fas fa-exclamation-triangle'},
    {id: 'fas fa-expand', name: 'expand', value: 'fas fa-expand'},
    {id: 'fas fa-expand-alt', name: 'expand-alt', value: 'fas fa-expand-alt'},
    {id: 'fas fa-external-link-alt', name: 'external-link-alt', value: 'fas fa-external-link-alt'},
    {id: 'fas fa-external-link-square-alt', name: 'external-link-square-alt', value: 'fas fa-external-link-square-alt'},
    {id: 'fas fa-eye', name: 'eye', value: 'fas fa-eye'},
    {id: 'fas fa-eye-dropper', name: 'eye-dropper', value: 'fas fa-eye-dropper'},
    {id: 'fas fa-eye-slash', name: 'eye-slash', value: 'fas fa-eye-slash'},
    {id: 'fas fa-fast-backward', name: 'fast-backward', value: 'fas fa-fast-backward'},
    {id: 'fas fa-fast-forward', name: 'fast-forward', value: 'fas fa-fast-forward'},
    {id: 'fas fa-fax', name: 'fax', value: 'fas fa-fax'},
    {id: 'fas fa-female', name: 'female', value: 'fas fa-female'},
    {id: 'fas fa-fighter-jet', name: 'fighter-jet', value: 'fas fa-fighter-jet'},
    {id: 'fas fa-file', name: 'file', value: 'fas fa-file'},
    {id: 'fas fa-file-alt', name: 'file-alt', value: 'fas fa-file-alt'},
    {id: 'fas fa-file-archive', name: 'file-archive', value: 'fas fa-file-archive'},
    {id: 'fas fa-file-audio', name: 'file-audio', value: 'fas fa-file-audio'},
    {id: 'fas fa-file-code', name: 'file-code', value: 'fas fa-file-code'},
    {id: 'fas fa-file-excel', name: 'file-excel', value: 'fas fa-file-excel'},
    {id: 'fas fa-file-image', name: 'file-image', value: 'fas fa-file-image'},
    {id: 'fas fa-file-medical', name: 'file-medical', value: 'fas fa-file-medical'},
    {id: 'fas fa-file-medical-alt', name: 'file-medical-alt', value: 'fas fa-file-medical-alt'},
    {id: 'fas fa-file-pdf', name: 'file-pdf', value: 'fas fa-file-pdf'},
    {id: 'fas fa-file-pow', name: 'file-pow', value: 'fas fa-file-pow'},
    {id: 'fas fa-file-video', name: 'file-video', value: 'fas fa-file-video'},
    {id: 'fas fa-file-word', name: 'file-word', value: 'fas fa-file-word'},
    {id: 'fas fa-film', name: 'film', value: 'fas fa-film'},
    {id: 'fas fa-filter', name: 'filter', value: 'fas fa-filter'},
    {id: 'fas fa-fire', name: 'fire', value: 'fas fa-fire'},
    {id: 'fas fa-fire-extinguisher', name: 'fire-extinguisher', value: 'fas fa-fire-extinguisher'},
    {id: 'fas fa-first-aid', name: 'first-aid', value: 'fas fa-first-aid'},
    {id: 'fas fa-flag', name: 'flag', value: 'fas fa-flag'},
    {id: 'fas fa-flag-checkered', name: 'flag-checkered', value: 'fas fa-flag-checkered'},
    {id: 'fas fa-flask', name: 'flask', value: 'fas fa-flask'},
    {id: 'fas fa-folder', name: 'folder', value: 'fas fa-folder'},
    {id: 'fas fa-folder-open', name: 'folder-open', value: 'fas fa-folder-open'},
    {id: 'fas fa-font', name: 'font', value: 'fas fa-font'},
    {id: 'fas fa-football-ball', name: 'football-ball', value: 'fas fa-football-ball'},
    {id: 'fas fa-forward', name: 'forward', value: 'fas fa-forward'},
    {id: 'fas fa-frown', name: 'frown', value: 'fas fa-frown'},
    {id: 'fas fa-futbol', name: 'futbol', value: 'fas fa-futbol'},
    {id: 'fas fa-gamepad', name: 'gamepad', value: 'fas fa-gamepad'},
    {id: 'fas fa-gavel', name: 'gavel', value: 'fas fa-gavel'},
    {id: 'fas fa-gem', name: 'gem', value: 'fas fa-gem'},
    {id: 'fas fa-genderless', name: 'genderless', value: 'fas fa-genderless'},
    {id: 'fas fa-gift', name: 'gift', value: 'fas fa-gift'},
    {id: 'fas fa-glass-martini', name: 'glass-martini', value: 'fas fa-glass-martini'},
    {id: 'fas fa-globe', name: 'globe', value: 'fas fa-globe'},
    {id: 'fas fa-golf-ball', name: 'golf-ball', value: 'fas fa-golf-ball'},
    {id: 'fas fa-graduation-cap', name: 'graduation-cap', value: 'fas fa-graduation-cap'},
    {id: 'fas fa-h-square', name: 'h-square', value: 'fas fa-h-square'},
    {id: 'fas fa-hand-holding', name: 'hand-holding', value: 'fas fa-hand-holding'},
    {id: 'fas fa-hand-holding-heart', name: 'hand-holding-heart', value: 'fas fa-hand-holding-heart'},
    {id: 'fas fa-hand-holding-usd', name: 'hand-holding-usd', value: 'fas fa-hand-holding-usd'},
    {id: 'fas fa-hand-lizard', name: 'hand-lizard', value: 'fas fa-hand-lizard'},
    {id: 'fas fa-hand-paper', name: 'hand-paper', value: 'fas fa-hand-paper'},
    {id: 'fas fa-hand-peace', name: 'hand-peace', value: 'fas fa-hand-peace'},
    {id: 'fas fa-hand-point-down', name: 'hand-point-down', value: 'fas fa-hand-point-down'},
    {id: 'fas fa-hand-point-left', name: 'hand-point-left', value: 'fas fa-hand-point-left'},
    {id: 'fas fa-hand-point-right', name: 'hand-point-right', value: 'fas fa-hand-point-right'},
    {id: 'fas fa-hand-point-up', name: 'hand-point-up', value: 'fas fa-hand-point-up'},
    {id: 'fas fa-hand-pointer', name: 'hand-pointer', value: 'fas fa-hand-pointer'},
    {id: 'fas fa-hand-rock', name: 'hand-rock', value: 'fas fa-hand-rock'},
    {id: 'fas fa-hand-scissors', name: 'hand-scissors', value: 'fas fa-hand-scissors'},
    {id: 'fas fa-hand-spock', name: 'hand-spock', value: 'fas fa-hand-spock'},
    {id: 'fas fa-hands', name: 'hands', value: 'fas fa-hands'},
    {id: 'fas fa-hands-helping', name: 'hands-helping', value: 'fas fa-hands-helping'},
    {id: 'fas fa-handshake', name: 'handshake', value: 'fas fa-handshake'},
    {id: 'fas fa-hashtag', name: 'hashtag', value: 'fas fa-hashtag'},
    {id: 'fas fa-hdd', name: 'hdd', value: 'fas fa-hdd'},
    {id: 'fas fa-heading', name: 'heading', value: 'fas fa-heading'},
    {id: 'fas fa-headphones', name: 'headphones', value: 'fas fa-headphones'},
    {id: 'fas fa-heart', name: 'heart', value: 'fas fa-heart'},
    {id: 'fas fa-heartbeat', name: 'heartbeat', value: 'fas fa-heartbeat'},
    {id: 'fas fa-history', name: 'history', value: 'fas fa-history'},
    {id: 'fas fa-hockey-puck', name: 'hockey-puck', value: 'fas fa-hockey-puck'},
    {id: 'fas fa-home', name: 'home', value: 'fas fa-home'},
    {id: 'fas fa-hospital', name: 'hospital', value: 'fas fa-hospital'},
    {id: 'fas fa-hospital-alt', name: 'hospital-alt', value: 'fas fa-hospital-alt'},
    {id: 'fas fa-hospital', name: 'hospital', value: 'fas fa-hospital'},
    {id: 'fas fa-hourglass', name: 'hourglass', value: 'fas fa-hourglass'},
    {id: 'fas fa-hourglass-end', name: 'hourglass-end', value: 'fas fa-hourglass-end'},
    {id: 'fas fa-hourglass-half', name: 'hourglass-half', value: 'fas fa-hourglass-half'},
    {id: 'fas fa-hourglass-start', name: 'hourglass-start', value: 'fas fa-hourglass-start'},
    {id: 'fas fa-i-cursor', name: 'i-cursor', value: 'fas fa-i-cursor'},
    {id: 'fas fa-id-badge', name: 'id-badge', value: 'fas fa-id-badge'},
    {id: 'fas fa-id-card', name: 'id-card', value: 'fas fa-id-card'},
    {id: 'fas fa-id-card-alt', name: 'id-card-alt', value: 'fas fa-id-card-alt'},
    {id: 'fas fa-image', name: 'image', value: 'fas fa-image'},
    {id: 'fas fa-images', name: 'images', value: 'fas fa-images'},
    {id: 'fas fa-inbox', name: 'inbox', value: 'fas fa-inbox'},
    {id: 'fas fa-indent', name: 'indent', value: 'fas fa-indent'},
    {id: 'fas fa-industry', name: 'industry', value: 'fas fa-industry'},
    {id: 'fas fa-info', name: 'info', value: 'fas fa-info'},
    {id: 'fas fa-info-circle', name: 'info-circle', value: 'fas fa-info-circle'},
    {id: 'fas fa-italic', name: 'italic', value: 'fas fa-italic'},
    {id: 'fas fa-key', name: 'key', value: 'fas fa-key'},
    {id: 'fas fa-keyboard', name: 'keyboard', value: 'fas fa-keyboard'},
    {id: 'fas fa-language', name: 'language', value: 'fas fa-language'},
    {id: 'fas fa-laptop', name: 'laptop', value: 'fas fa-laptop'},
    {id: 'fas fa-leaf', name: 'leaf', value: 'fas fa-leaf'},
    {id: 'fas fa-lemon', name: 'lemon', value: 'fas fa-lemon'},
    {id: 'fas fa-level-down-alt', name: 'level-down-alt', value: 'fas fa-level-down-alt'},
    {id: 'fas fa-level-up-alt', name: 'level-up-alt', value: 'fas fa-level-up-alt'},
    {id: 'fas fa-life-ring', name: 'life-ring', value: 'fas fa-life-ring'},
    {id: 'fas fa-lightbulb', name: 'lightbulb', value: 'fas fa-lightbulb'},
    {id: 'fas fa-link', name: 'link', value: 'fas fa-link'},
    {id: 'fas fa-lira-sign', name: 'lira-sign', value: 'fas fa-lira-sign'},
    {id: 'fas fa-list', name: 'list', value: 'fas fa-list'},
    {id: 'fas fa-list-alt', name: 'list-alt', value: 'fas fa-list-alt'},
    {id: 'fas fa-list-ol', name: 'list-ol', value: 'fas fa-list-ol'},
    {id: 'fas fa-list-ul', name: 'list-ul', value: 'fas fa-list-ul'},
    {id: 'fas fa-location-arrow', name: 'location-arrow', value: 'fas fa-location-arrow'},
    {id: 'fas fa-lock', name: 'lock', value: 'fas fa-lock'},
    {id: 'fas fa-lock-open', name: 'lock-open', value: 'fas fa-lock-open'},
    {id: 'fas fa-long-arrow-alt-down', name: 'long-arrow-alt-down', value: 'fas fa-long-arrow-alt-down'},
    {id: 'fas fa-long-arrow-alt-left', name: 'long-arrow-alt-left', value: 'fas fa-long-arrow-alt-left'},
    {id: 'fas fa-long-arrow-alt-right', name: 'long-arrow-alt-right', value: 'fas fa-long-arrow-alt-right'},
    {id: 'fas fa-long-arrow-alt-up', name: 'long-arrow-alt-up', value: 'fas fa-long-arrow-alt-up'},
    {id: 'fas fa-low-vision', name: 'low-vision', value: 'fas fa-low-vision'},
    {id: 'fas fa-magic', name: 'magic', value: 'fas fa-magic'},
    {id: 'fas fa-magnet', name: 'magnet', value: 'fas fa-magnet'},
    {id: 'fas fa-male', name: 'male', value: 'fas fa-male'},
    {id: 'fas fa-map', name: 'map', value: 'fas fa-map'},
    {id: 'fas fa-map-marker', name: 'map-marker', value: 'fas fa-map-marker'},
    {id: 'fas fa-map-marker-alt', name: 'map-marker-alt', value: 'fas fa-map-marker-alt'},
    {id: 'fas fa-map-pin', name: 'map-pin', value: 'fas fa-map-pin'},
    {id: 'fas fa-map-signs', name: 'map-signs', value: 'fas fa-map-signs'},
    {id: 'fas fa-mars', name: 'mars', value: 'fas fa-mars'},
    {id: 'fas fa-mars-double', name: 'mars-double', value: 'fas fa-mars-double'},
    {id: 'fas fa-mars-stroke', name: 'mars-stroke', value: 'fas fa-mars-stroke'},
    {id: 'fas fa-mars-stroke-h', name: 'mars-stroke-h', value: 'fas fa-mars-stroke-h'},
    {id: 'fas fa-mars-stroke-v', name: 'mars-stroke-v', value: 'fas fa-mars-stroke-v'},
    {id: 'fas fa-medkit', name: 'medkit', value: 'fas fa-medkit'},
    {id: 'fas fa-meh', name: 'meh', value: 'fas fa-meh'},
    {id: 'fas fa-mercury', name: 'mercury', value: 'fas fa-mercury'},
    {id: 'fas fa-microchip', name: 'microchip', value: 'fas fa-microchip'},
    {id: 'fas fa-microphone', name: 'microphone', value: 'fas fa-microphone'},
    {id: 'fas fa-microphone-slash', name: 'microphone-slash', value: 'fas fa-microphone-slash'},
    {id: 'fas fa-minus', name: 'minus', value: 'fas fa-minus'},
    {id: 'fas fa-minus-circle', name: 'minus-circle', value: 'fas fa-minus-circle'},
    {id: 'fas fa-minus-square', name: 'minus-square', value: 'fas fa-minus-square'},
    {id: 'fas fa-mobile', name: 'mobile', value: 'fas fa-mobile'},
    {id: 'fas fa-mobile-alt', name: 'mobile-alt', value: 'fas fa-mobile-alt'},
    {id: 'fas money-bill-alt', name: 'ey-bill-alt', value: 'fas money-bill-alt'},
    {id: 'fas fa-moon', name: 'moon', value: 'fas fa-moon'},
    {id: 'fas fa-motorcycle', name: 'motorcycle', value: 'fas fa-motorcycle'},
    {id: 'fas fa-mouse-pointer', name: 'mouse-pointer', value: 'fas fa-mouse-pointer'},
    {id: 'fas fa-music', name: 'music', value: 'fas fa-music'},
    {id: 'fas fa-neuter', name: 'neuter', value: 'fas fa-neuter'},
    {id: 'fas fa-newspaper', name: 'newspaper', value: 'fas fa-newspaper'},
    {id: 'fas fa-notes-medical', name: 'notes-medical', value: 'fas fa-notes-medical'},
    {id: 'fas fa-object-group', name: 'object-group', value: 'fas fa-object-group'},
    {id: 'fas fa-object-ungroup', name: 'object-ungroup', value: 'fas fa-object-ungroup'},
    {id: 'fas fa-outdent', name: 'outdent', value: 'fas fa-outdent'},
    {id: 'fas fa-paint-brush', name: 'paint-brush', value: 'fas fa-paint-brush'},
    {id: 'fas fa-pallet', name: 'pallet', value: 'fas fa-pallet'},
    {id: 'fas fa-paper-plane', name: 'paper-plane', value: 'fas fa-paper-plane'},
    {id: 'fas fa-paperclip', name: 'paperclip', value: 'fas fa-paperclip'},
    {id: 'fas fa-parachute-box', name: 'parachute-box', value: 'fas fa-parachute-box'},
    {id: 'fas fa-paragraph', name: 'paragraph', value: 'fas fa-paragraph'},
    {id: 'fas fa-paste', name: 'paste', value: 'fas fa-paste'},
    {id: 'fas fa-pause', name: 'pause', value: 'fas fa-pause'},
    {id: 'fas pause-circle', name: 'se-circle', value: 'fas pause-circle'},
    {id: 'fas fa-fa-paw', name: 'fa-paw', value: 'fas fa-fa-paw'},
    {id: 'fas fa-pen-square', name: 'pen-square', value: 'fas fa-pen-square'},
    {id: 'fas fa-pencil-alt', name: 'pencil-alt', value: 'fas fa-pencil-alt'},
    {id: 'fas fa-people-carry', name: 'people-carry', value: 'fas fa-people-carry'},
    {id: 'fas fa-percent', name: 'percent', value: 'fas fa-percent'},
    {id: 'fas fa-phone', name: 'phone', value: 'fas fa-phone'},
    {id: 'fas fa-phone-slash', name: 'phone-slash', value: 'fas fa-phone-slash'},
    {id: 'fas fa-phone-square', name: 'phone-square', value: 'fas fa-phone-square'},
    {id: 'fas fa-phone-volume', name: 'phone-volume', value: 'fas fa-phone-volume'},
    {id: 'fas fa-piggy-bank', name: 'piggy-bank', value: 'fas fa-piggy-bank'},
    {id: 'fas fa-pills', name: 'pills', value: 'fas fa-pills'},
    {id: 'fas fa-plane', name: 'plane', value: 'fas fa-plane'},
    {id: 'fas fa-play', name: 'play', value: 'fas fa-play'},
    {id: 'fas fa-play-circle', name: 'play-circle', value: 'fas fa-play-circle'},
    {id: 'fas fa-plug', name: 'plug', value: 'fas fa-plug'},
    {id: 'fas fa-plus', name: 'plus', value: 'fas fa-plus'},
    {id: 'fas fa-plus-circle', name: 'plus-circle', value: 'fas fa-plus-circle'},
    {id: 'fas fa-plus-square', name: 'plus-square', value: 'fas fa-plus-square'},
    {id: 'fas fa-podcast', name: 'podcast', value: 'fas fa-podcast'},
    {id: 'fas fa-poo', name: 'poo', value: 'fas fa-poo'},
    {id: 'fas fa-pound-sign', name: 'pound-sign', value: 'fas fa-pound-sign'},
    {id: 'fas fa-power-off', name: 'power-off', value: 'fas fa-power-off'},
    {id: 'fas fa-prescription-bottle', name: 'prescription-bottle', value: 'fas fa-prescription-bottle'},
    {id: 'fas fa-prescription-bottle-alt', name: 'prescription-bottle-alt', value: 'fas fa-prescription-bottle-alt'},
    {id: 'fas fa-print', name: 'print', value: 'fas fa-print'},
    {id: 'fas fa-procedures', name: 'procedures', value: 'fas fa-procedures'},
    {id: 'fas fa-puzzle-piece', name: 'puzzle-piece', value: 'fas fa-puzzle-piece'},
    {id: 'fas fa-qrcode', name: 'qrcode', value: 'fas fa-qrcode'},
    {id: 'fas fa-question', name: 'question', value: 'fas fa-question'},
    {id: 'fas fa-question', name: 'question', value: 'fas fa-question'},
    {id: 'fas fa-quidditch', name: 'quidditch', value: 'fas fa-quidditch'},
    {id: 'fas fa-quote-left', name: 'quote-left', value: 'fas fa-quote-left'},
    {id: 'fas fa-quote-right', name: 'quote-right', value: 'fas fa-quote-right'},
    {id: 'fas fa-random', name: 'random', value: 'fas fa-random'},
    {id: 'fas fa-recycle', name: 'recycle', value: 'fas fa-recycle'},
    {id: 'fas fa-redo', name: 'redo', value: 'fas fa-redo'},
    {id: 'fas fa-redo-alt', name: 'redo-alt', value: 'fas fa-redo-alt'},
    {id: 'fas fa-registered', name: 'registered', value: 'fas fa-registered'},
    {id: 'fas fa-reply', name: 'reply', value: 'fas fa-reply'},
    {id: 'fas fa-reply-all', name: 'reply-all', value: 'fas fa-reply-all'},
    {id: 'fas fa-retweet', name: 'retweet', value: 'fas fa-retweet'},
    {id: 'fas fa-ribbon', name: 'ribbon', value: 'fas fa-ribbon'},
    {id: 'fas fa-road', name: 'road', value: 'fas fa-road'},
    {id: 'fas fa-rocket', name: 'rocket', value: 'fas fa-rocket'},
    {id: 'fas fa-rss', name: 'rss', value: 'fas fa-rss'},
    {id: 'fas fa-rss-square', name: 'rss-square', value: 'fas fa-rss-square'},
    {id: 'fas fa-ruble-sign', name: 'ruble-sign', value: 'fas fa-ruble-sign'},
    {id: 'fas fa-rupee-sign', name: 'rupee-sign', value: 'fas fa-rupee-sign'},
    {id: 'fas fa-save', name: 'save', value: 'fas fa-save'},
    {id: 'fas fa-search', name: 'search', value: 'fas fa-search'},
    {id: 'fas fa-search-minus', name: 'search-minus', value: 'fas fa-search-minus'},
    {id: 'fas fa-search-plus', name: 'search-plus', value: 'fas fa-search-plus'},
    {id: 'fas fa-seedling', name: 'seedling', value: 'fas fa-seedling'},
    {id: 'fas fa-server', name: 'server', value: 'fas fa-server'},
    {id: 'fas fa-share', name: 'share', value: 'fas fa-share'},
    {id: 'fas fa-share-alt', name: 'share-alt', value: 'fas fa-share-alt'},
    {id: 'fas fa-share-alt-square', name: 'share-alt-square', value: 'fas fa-share-alt-square'},
    {id: 'fas fa-share-square', name: 'share-square', value: 'fas fa-share-square'},
    {id: 'fas fa-shekel-sign', name: 'shekel-sign', value: 'fas fa-shekel-sign'},
    {id: 'fas fa-shield-alt', name: 'shield-alt', value: 'fas fa-shield-alt'},
    {id: 'fas fa-ship', name: 'ship', value: 'fas fa-ship'},
    {id: 'fas fa-shipping-fast', name: 'shipping-fast', value: 'fas fa-shipping-fast'},
    {id: 'fas fa-shopping-bag', name: 'shopping-bag', value: 'fas fa-shopping-bag'},
    {id: 'fas fa-shopping-basket', name: 'shopping-basket', value: 'fas fa-shopping-basket'},
    {id: 'fas fa-shopping-cart', name: 'shopping-cart', value: 'fas fa-shopping-cart'},
    {id: 'fas fa-shower', name: 'shower', value: 'fas fa-shower'},
    {id: 'fas fa-sign', name: 'sign', value: 'fas fa-sign'},
    {id: 'fas fa-sign-in-alt', name: 'sign-in-alt', value: 'fas fa-sign-in-alt'},
    {id: 'fas fa-sign-language', name: 'sign-language', value: 'fas fa-sign-language'},
    {id: 'fas fa-sign-out-alt', name: 'sign-out-alt', value: 'fas fa-sign-out-alt'},
    {id: 'fas fa-signal', name: 'signal', value: 'fas fa-signal'},
    {id: 'fas fa-sitemap', name: 'sitemap', value: 'fas fa-sitemap'},
    {id: 'fas fa-sliders-h', name: 'sliders-h', value: 'fas fa-sliders-h'},
    {id: 'fas fa-smile', name: 'smile', value: 'fas fa-smile'},
    {id: 'fas fa-smoking', name: 'smoking', value: 'fas fa-smoking'},
    {id: 'fas fa-snowflake', name: 'snowflake', value: 'fas fa-snowflake'},
    {id: 'fas fa-sort', name: 'sort', value: 'fas fa-sort'},
    {id: 'fas fa-alpha-down', name: 'alpha-down', value: 'fas fa-alpha-down'},
    {id: 'fas fa-sort-alpha-up', name: 'sort-alpha-up', value: 'fas fa-sort-alpha-up'},
    {id: 'fas fa-sort-amount-down', name: 'sort-amount-down', value: 'fas fa-sort-amount-down'},
    {id: 'fas fa-sort-amount-up', name: 'sort-amount-up', value: 'fas fa-sort-amount-up'},
    {id: 'fas fa-sort-down', name: 'sort-down', value: 'fas fa-sort-down'},
    {id: 'fas fa-sort-numeric-down', name: 'sort-numeric-down', value: 'fas fa-sort-numeric-down'},
    {id: 'fas fa-sort-numeric-up', name: 'sort-numeric-up', value: 'fas fa-sort-numeric-up'},
    {id: 'fas fa-sort-up', name: 'sort-up', value: 'fas fa-sort-up'},
    {id: 'fas fa-space-shuttle', name: 'space-shuttle', value: 'fas fa-space-shuttle'},
    {id: 'fas fa-spinner', name: 'spinner', value: 'fas fa-spinner'},
    {id: 'fas fa-square', name: 'square', value: 'fas fa-square'},
    {id: 'fas fa-square-full', name: 'square-full', value: 'fas fa-square-full'},
    {id: 'fas fa-star', name: 'star', value: 'fas fa-star'},
    {id: 'fas fa-star-half', name: 'star-half', value: 'fas fa-star-half'},
    {id: 'fas fa-step-backward', name: 'step-backward', value: 'fas fa-step-backward'},
    {id: 'fas fa-step-forward', name: 'step-forward', value: 'fas fa-step-forward'},
    {id: 'fas fa-stethoscope', name: 'stethoscope', value: 'fas fa-stethoscope'},
    {id: 'fas fa-sticky-note', name: 'sticky-note', value: 'fas fa-sticky-note'},
    {id: 'fas fa-stop', name: 'stop', value: 'fas fa-stop'},
    {id: 'fas fa-stop-circle', name: 'stop-circle', value: 'fas fa-stop-circle'},
    {id: 'fas fa-stopwatch', name: 'stopwatch', value: 'fas fa-stopwatch'},
    {id: 'fas fa-street-view', name: 'street-view', value: 'fas fa-street-view'},
    {id: 'fas fa-strikethrough', name: 'strikethrough', value: 'fas fa-strikethrough'},
    {id: 'fas fa-subscript', name: 'subscript', value: 'fas fa-subscript'},
    {id: 'fas fa-subway', name: 'subway', value: 'fas fa-subway'},
    {id: 'fas fa-suitcase', name: 'suitcase', value: 'fas fa-suitcase'},
    {id: 'fas fa-sun', name: 'sun', value: 'fas fa-sun'},
    {id: 'fas fa-superscript', name: 'superscript', value: 'fas fa-superscript'},
    {id: 'fas fa-sync', name: 'sync', value: 'fas fa-sync'},
    {id: 'fas fa-sync-alt', name: 'sync-alt', value: 'fas fa-sync-alt'},
    {id: 'fas fa-syringe', name: 'syringe', value: 'fas fa-syringe'},
    {id: 'fas fa-table', name: 'table', value: 'fas fa-table'},
    {id: 'fas fa-table-tennis', name: 'table-tennis', value: 'fas fa-table-tennis'},
    {id: 'fas fa-tablet', name: 'tablet', value: 'fas fa-tablet'},
    {id: 'fas fa-tablet-alt', name: 'tablet-alt', value: 'fas fa-tablet-alt'},
    {id: 'fas fa-tablets', name: 'tablets', value: 'fas fa-tablets'},
    {id: 'fas fa-tachometer-alt', name: 'tachometer-alt', value: 'fas fa-tachometer-alt'},
    {id: 'fas fa-tag', name: 'tag', value: 'fas fa-tag'},
    {id: 'fas fa-tags', name: 'tags', value: 'fas fa-tags'},
    {id: 'fas fa-tape', name: 'tape', value: 'fas fa-tape'},
    {id: 'fas fa-tasks', name: 'tasks', value: 'fas fa-tasks'},
    {id: 'fas fa-taxi', name: 'taxi', value: 'fas fa-taxi'},
    {id: 'fas fa-terminal', name: 'terminal', value: 'fas fa-terminal'},
    {id: 'fas fa-text-height', name: 'text-height', value: 'fas fa-text-height'},
    {id: 'fas fa-text-width', name: 'text-width', value: 'fas fa-text-width'},
    {id: 'fas fa-th', name: 'th', value: 'fas fa-th'},
    {id: 'fas fa-th-large', name: 'th-large', value: 'fas fa-th-large'},
    {id: 'fas fa-th-list', name: 'th-list', value: 'fas fa-th-list'},
    {id: 'fas fa-thermometer', name: 'thermometer', value: 'fas fa-thermometer'},
    {id: 'fas fa-thermometer-empty', name: 'thermometer-empty', value: 'fas fa-thermometer-empty'},
    {id: 'fas fa-thermometer-full', name: 'thermometer-full', value: 'fas fa-thermometer-full'},
    {id: 'fas fa-thermometer-half', name: 'thermometer-half', value: 'fas fa-thermometer-half'},
    {id: 'fas fa-thermometer-quarter', name: 'thermometer-quarter', value: 'fas fa-thermometer-quarter'},
    {
        id: 'fas fa-thermometer-three-quarters',
        name: 'thermometer-three-quarters',
        value: 'fas fa-thermometer-three-quarters'
    },
    {id: 'fas fa-thumbs-down', name: 'thumbs-down', value: 'fas fa-thumbs-down'},
    {id: 'fas fa-thumbs-up', name: 'thumbs-up', value: 'fas fa-thumbs-up'},
    {id: 'fas fa-thumbtack', name: 'thumbtack', value: 'fas fa-thumbtack'},
    {id: 'fas fa-ticket-alt', name: 'ticket-alt', value: 'fas fa-ticket-alt'},
    {id: 'fas fa-times', name: 'times', value: 'fas fa-times'},
    {id: 'fas fa-times-circle', name: 'times-circle', value: 'fas fa-times-circle'},
    {id: 'fas fa-tint', name: 'tint', value: 'fas fa-tint'},
    {id: 'fas fa-toggle-off', name: 'toggle-off', value: 'fas fa-toggle-off'},
    {id: 'fas fa-toggle-on', name: 'toggle-on', value: 'fas fa-toggle-on'},
    {id: 'fas fa-trademark', name: 'trademark', value: 'fas fa-trademark'},
    {id: 'fas fa-train', name: 'train', value: 'fas fa-train'},
    {id: 'fas fa-transgender', name: 'transgender', value: 'fas fa-transgender'},
    {id: 'fas fa-transgen', name: 'transgen', value: 'fas fa-transgen'},
    {id: 'fas fa-trash', name: 'trash', value: 'fas fa-trash'},
    {id: 'fas fa-trash-alt', name: 'trash-alt', value: 'fas fa-trash-alt'},
    {id: 'fas fa-tree', name: 'tree', value: 'fas fa-tree'},
    {id: 'fas fa-trophy', name: 'trophy', value: 'fas fa-trophy'},
    {id: 'fas fa-truck', name: 'truck', value: 'fas fa-truck'},
    {id: 'fas fa-truck-loading', name: 'truck-loading', value: 'fas fa-truck-loading'},
    {id: 'fas fa-truck-moving', name: 'truck-moving', value: 'fas fa-truck-moving'},
    {id: 'fas fa-tty', name: 'tty', value: 'fas fa-tty'},
    {id: 'fas fa-tv', name: 'tv', value: 'fas fa-tv'},
    {id: 'fas fa-umbrella', name: 'umbrella', value: 'fas fa-umbrella'},
    {id: 'fas fa-underline', name: 'underline', value: 'fas fa-underline'},
    {id: 'fas fa-undo', name: 'undo', value: 'fas fa-undo'},
    {id: 'fas fa-undo-alt', name: 'undo-alt', value: 'fas fa-undo-alt'},
    {id: 'fas fa-universal-access', name: 'universal-access', value: 'fas fa-universal-access'},
    {id: 'fas fa-university', name: 'university', value: 'fas fa-university'},
    {id: 'fas fa-unlink', name: 'unlink', value: 'fas fa-unlink'},
    {id: 'fas fa-unlock', name: 'unlock', value: 'fas fa-unlock'},
    {id: 'fas fa-unlock-alt', name: 'unlock-alt', value: 'fas fa-unlock-alt'},
    {id: 'fas fa-upload', name: 'upload', value: 'fas fa-upload'},
    {id: 'fas fa-user', name: 'user', value: 'fas fa-user'},
    {id: 'fas fa-user-circle', name: 'user-circle', value: 'fas fa-user-circle'},
    {id: 'fas fa-user-md', name: 'user-md', value: 'fas fa-user-md'},
    {id: 'fas fa-user-plus', name: 'user-plus', value: 'fas fa-user-plus'},
    {id: 'fas fa-user-secret', name: 'user-secret', value: 'fas fa-user-secret'},
    {id: 'fas fa-user-times', name: 'user-times', value: 'fas fa-user-times'},
    {id: 'fas fa-users', name: 'users', value: 'fas fa-users'},
    {id: 'fas fa-utensil-spoon', name: 'utensil-spoon', value: 'fas fa-utensil-spoon'},
    {id: 'fas fa-utensils', name: 'utensils', value: 'fas fa-utensils'},
    {id: 'fas fa-venus', name: 'venus', value: 'fas fa-venus'},
    {id: 'fas fa-venus-double', name: 'venus-double', value: 'fas fa-venus-double'},
    {id: 'fas fa-venus-mars', name: 'venus-mars', value: 'fas fa-venus-mars'},
    {id: 'fas fa-vial', name: 'vial', value: 'fas fa-vial'},
    {id: 'fas fa-vials', name: 'vials', value: 'fas fa-vials'},
    {id: 'fas fa-video', name: 'video', value: 'fas fa-video'},
    {id: 'fas fa-video-slash', name: 'video-slash', value: 'fas fa-video-slash'},
    {id: 'fas fa-volleyba', name: 'volleyba', value: 'fas fa-volleyba'},
    {id: 'fas fa-volume-down', name: 'volume-down', value: 'fas fa-volume-down'},
    {id: 'fas fa-volume-off', name: 'volume-off', value: 'fas fa-volume-off'},
    {id: 'fas fa-volume-up', name: 'volume-up', value: 'fas fa-volume-up'},
    {id: 'fas fa-warehouse', name: 'warehouse', value: 'fas fa-warehouse'},
    {id: 'fas fa-weight', name: 'weight', value: 'fas fa-weight'},
    {id: 'fas fa-wheelchair', name: 'wheelchair', value: 'fas fa-wheelchair'},
    {id: 'fas fa-wifi', name: 'wifi', value: 'fas fa-wifi'},
    {id: 'fas fa-window-close', name: 'window-close', value: 'fas fa-window-close'},
    {id: 'fas fa-window-maximize', name: 'window-maximize', value: 'fas fa-window-maximize'},
    {id: 'fas fa-window-minimize', name: 'window-minimize', value: 'fas fa-window-minimize'},
    {id: 'fas fa-window-restore', name: 'window-restore', value: 'fas fa-window-restore'},
    {id: 'fas fa-wine-glass', name: 'wine-glass', value: 'fas fa-wine-glass'},
    {id: 'fas fa-won-sign', name: 'won-sign', value: 'fas fa-won-sign'},
    {id: 'fas fa-wrench', name: 'wrench', value: 'fas fa-wrench'},
    {id: 'fas fa-x-ray', name: 'x-ray', value: 'fas fa-x-ray'},
    {id: 'fas fa-yen-sign', name: 'yen-sign', value: 'fas fa-yen-sign'},
    {id: 'far fa-address-book', name: 'address-book', value: 'far fa-address-book'},
    {id: 'far fa-address-card', name: 'address-card', value: 'far fa-address-card'},
    {id: 'far fa-arrow-alt-circle-down', name: 'arrow-alt-circle-down', value: 'far fa-arrow-alt-circle-down'},
    {id: 'far fa-arrow-alt-circle-left', name: 'arrow-alt-circle-left', value: 'far fa-arrow-alt-circle-left'},
    {id: 'far fa-arrow-alt-circle-right', name: 'arrow-alt-circle-right', value: 'far fa-arrow-alt-circle-right'},
    {id: 'far fa-arrow-alt-circle-up', name: 'arrow-alt-circle-up', value: 'far fa-arrow-alt-circle-up'},
    {id: 'far fa-bell', name: 'bell', value: 'far fa-bell'},
    {id: 'far fa-bell-slash', name: 'bell-slash', value: 'far fa-bell-slash'},
    {id: 'far fa-bookmark', name: 'bookmark', value: 'far fa-bookmark'},
    {id: 'far fa-building', name: 'building', value: 'far fa-building'},
    {id: 'far fa-calendar', name: 'calendar', value: 'far fa-calendar'},
    {id: 'far fa-calendar-alt', name: 'calendar-alt', value: 'far fa-calendar-alt'},
    {id: 'far fa-calendar-check', name: 'calendar-check', value: 'far fa-calendar-check'},
    {id: 'far fa-calendar-minus', name: 'calendar-minus', value: 'far fa-calendar-minus'},
    {id: 'far fa-calendar-plus', name: 'calendar-plus', value: 'far fa-calendar-plus'},
    {id: 'far fa-calendar-times', name: 'calendar-times', value: 'far fa-calendar-times'},
    {id: 'far fa-caret-square-down', name: 'caret-square-down', value: 'far fa-caret-square-down'},
    {id: 'far fa-caret-square-left', name: 'caret-square-left', value: 'far fa-caret-square-left'},
    {id: 'far fa-caret-square-right', name: 'caret-square-right', value: 'far fa-caret-square-right'},
    {id: 'far fa-caret-square-up', name: 'caret-square-up', value: 'far fa-caret-square-up'},
    {id: 'far fa-chart-bar', name: 'chart-bar', value: 'far fa-chart-bar'},
    {id: 'far fa-check-circle', name: 'check-circle', value: 'far fa-check-circle'},
    {id: 'far fa-check-square', name: 'check-square', value: 'far fa-check-square'},
    {id: 'far fa-circle', name: 'circle', value: 'far fa-circle'},
    {id: 'far fa-clipboard', name: 'clipboard', value: 'far fa-clipboard'},
    {id: 'far fa-clock', name: 'clock', value: 'far fa-clock'},
    {id: 'far fa-clone', name: 'clone', value: 'far fa-clone'},
    {id: 'far fa-closed-captioning', name: 'closed-captioning', value: 'far fa-closed-captioning'},
    {id: 'far fa-comment', name: 'comment', value: 'far fa-comment'},
    {id: 'far fa-comment-alt', name: 'comment-alt', value: 'far fa-comment-alt'},
    {id: 'far fa-comments', name: 'comments', value: 'far fa-comments'},
    {id: 'far fa-compass', name: 'compass', value: 'far fa-compass'},
    {id: 'far fa-copy', name: 'copy', value: 'far fa-copy'},
    {id: 'far fa-copyright', name: 'copyright', value: 'far fa-copyright'},
    {id: 'far fa-credit-card', name: 'credit-card', value: 'far fa-credit-card'},
    {id: 'far fa-dot-circle', name: 'dot-circle', value: 'far fa-dot-circle'},
    {id: 'far fa-edit', name: 'edit', value: 'far fa-edit'},
    {id: 'far fa-envelope', name: 'envelope', value: 'far fa-envelope'},
    {id: 'far fa-envelope-open', name: 'envelope-open', value: 'far fa-envelope-open'},
    {id: 'far fa-eye-slash', name: 'eye-slash', value: 'far fa-eye-slash'},
    {id: 'far fa-file', name: 'file', value: 'far fa-file'},
    {id: 'far fa-file-alt', name: 'file-alt', value: 'far fa-file-alt'},
    {id: 'far fa-file-archive', name: 'file-archive', value: 'far fa-file-archive'},
    {id: 'far fa-file-audio', name: 'file-audio', value: 'far fa-file-audio'},
    {id: 'far fa-file-code', name: 'file-code', value: 'far fa-file-code'},
    {id: 'far fa-file-excel', name: 'file-excel', value: 'far fa-file-excel'},
    {id: 'far fa-file-image', name: 'file-image', value: 'far fa-file-image'},
    {id: 'far fa-file-pdf', name: 'file-pdf', value: 'far fa-file-pdf'},
    {id: 'far fa-file-powerpoint', name: 'file-powerpoint', value: 'far fa-file-powerpoint'},
    {id: 'far fa-file-video', name: 'file-video', value: 'far fa-file-video'},
    {id: 'far fa-file-word', name: 'file-word', value: 'far fa-file-word'},
    {id: 'far fa-flag', name: 'flag', value: 'far fa-flag'},
    {id: 'far fa-folder', name: 'folder', value: 'far fa-folder'},
    {id: 'far fa-folder-open', name: 'folder-open', value: 'far fa-folder-open'},
    {id: 'far fa-frown', name: 'frown', value: 'far fa-frown'},
    {id: 'far fa-futbol', name: 'futbol', value: 'far fa-futbol'},
    {id: 'far fa-gem', name: 'gem', value: 'far fa-gem'},
    {id: 'far fa-hand-lizard', name: 'hand-lizard', value: 'far fa-hand-lizard'},
    {id: 'far fa-hand-paper', name: 'hand-paper', value: 'far fa-hand-paper'},
    {id: 'far fa-hand-peace', name: 'hand-peace', value: 'far fa-hand-peace'},
    {id: 'far fa-hand-point-down', name: 'hand-point-down', value: 'far fa-hand-point-down'},
    {id: 'far fa-hand-point-left', name: 'hand-point-left', value: 'far fa-hand-point-left'},
    {id: 'far fa-hand-point-right', name: 'hand-point-right', value: 'far fa-hand-point-right'},
    {id: 'far fa-hand-point-up', name: 'hand-point-up', value: 'far fa-hand-point-up'},
    {id: 'far fa-hand-pointer', name: 'hand-pointer', value: 'far fa-hand-pointer'},
    {id: 'far fa-hand-rock', name: 'hand-rock', value: 'far fa-hand-rock'},
    {id: 'far fa-hand-scissors', name: 'hand-scissors', value: 'far fa-hand-scissors'},
    {id: 'far fa-hand-spock', name: 'hand-spock', value: 'far fa-hand-spock'},
    {id: 'far fa-handshake', name: 'handshake', value: 'far fa-handshake'},
    {id: 'far fa-hdd', name: 'hdd', value: 'far fa-hdd'},
    {id: 'far fa-heart', name: 'heart', value: 'far fa-heart'},
    {id: 'far fa-hospital', name: 'hospital', value: 'far fa-hospital'},
    {id: 'far fa-hourglass', name: 'hourglass', value: 'far fa-hourglass'},
    {id: 'far fa-id-badge', name: 'id-badge', value: 'far fa-id-badge'},
    {id: 'far fa-id-card', name: 'id-card', value: 'far fa-id-card'},
    {id: 'far fa-image', name: 'image', value: 'far fa-image'},
    {id: 'far fa-images', name: 'images', value: 'far fa-images'},
    {id: 'far fa-keyboard', name: 'keyboard', value: 'far fa-keyboard'},
    {id: 'far fa-lemon', name: 'lemon', value: 'far fa-lemon'},
    {id: 'far fa-life-ring', name: 'life-ring', value: 'far fa-life-ring'},
    {id: 'far fa-lightbulb', name: 'lightbulb', value: 'far fa-lightbulb'},
    {id: 'far fa-list-alt', name: 'list-alt', value: 'far fa-list-alt'},
    {id: 'far fa-map', name: 'map', value: 'far fa-map'},
    {id: 'far fa-meh', name: 'meh', value: 'far fa-meh'},
    {id: 'far fa-minus-square', name: 'minus-square', value: 'far fa-minus-square'},
    {id: 'far fa-money-bill-alt', name: 'money-bill-alt', value: 'far fa-money-bill-alt'},
    {id: 'far fa-moon', name: 'moon', value: 'far fa-moon'},
    {id: 'far fa-newspaper', name: 'newspaper', value: 'far fa-newspaper'},
    {id: 'far fa-object-group', name: 'object-group', value: 'far fa-object-group'},
    {id: 'far fa-object-ungroup', name: 'object-ungroup', value: 'far fa-object-ungroup'},
    {id: 'far fa-paper-plane', name: 'paper-plane', value: 'far fa-paper-plane'},
    {id: 'far fa-pause-circle', name: 'pause-circle', value: 'far fa-pause-circle'},
    {id: 'far fa-play-circle', name: 'play-circle', value: 'far fa-play-circle'},
    {id: 'far fa-plus-square', name: 'plus-square', value: 'far fa-plus-square'},
    {id: 'far fa-question-circle', name: 'question-circle', value: 'far fa-question-circle'},
    {id: 'far fa-registered', name: 'registered', value: 'far fa-registered'},
    {id: 'far fa-save', name: 'save', value: 'far fa-save'},
    {id: 'far fa-share-square', name: 'share-square', value: 'far fa-share-square'},
    {id: 'far fa-smile', name: 'smile', value: 'far fa-smile'},
    {id: 'far fa-snowflake', name: 'snowflake', value: 'far fa-snowflake'},
    {id: 'far fa-square', name: 'square', value: 'far fa-square'},
    {id: 'far fa-star', name: 'star', value: 'far fa-star'},
    {id: 'far fa-star-half', name: 'star-half', value: 'far fa-star-half'},
    {id: 'far fa-sticky-note', name: 'sticky-note', value: 'far fa-sticky-note'},
    {id: 'far fa-stop-circle', name: 'stop-circle', value: 'far fa-stop-circle'},
    {id: 'far fa-sun', name: 'sun', value: 'far fa-sun'},
    {id: 'far fa-thumbs-down', name: 'thumbs-down', value: 'far fa-thumbs-down'},
    {id: 'far fa-thumbs-up', name: 'thumbs-up', value: 'far fa-thumbs-up'},
    {id: 'far fa-times-circle', name: 'times-circle', value: 'far fa-times-circle'},
    {id: 'far fa-trash-alt', name: 'trash-alt', value: 'far fa-trash-alt'},
    {id: 'far fa-user', name: 'user', value: 'far fa-user'},
    {id: 'far fa-user-circle', name: 'user-circle', value: 'far fa-user-circle'},
    {id: 'far fa-window-close', name: 'window-close', value: 'far fa-window-close'},
    {id: 'far fa-window-maximize', name: 'window-maximize', value: 'far fa-window-maximize'},
    {id: 'far fa-window-minimize', name: 'window-minimize', value: 'far fa-window-minimize'},
    {id: 'far fa-window-restore', name: 'window-restore', value: 'far fa-window-restore'},
    {id: 'fab fa-500px', name: '500px', value: 'fab fa-500px'},
    {id: 'fab fa-accessible-icon', name: 'accessible-icon', value: 'fab fa-accessible-icon'},
    {id: 'fab fa-accusoft', name: 'accusoft', value: 'fab fa-accusoft'},
    {id: 'fab fa-adn', name: 'adn', value: 'fab fa-adn'},
    {id: 'fab fa-adversal', name: 'adversal', value: 'fab fa-adversal'},
    {id: 'fab fa-affiliatetheme', name: 'affiliatetheme', value: 'fab fa-affiliatetheme'},
    {id: 'fab fa-algolia', name: 'algolia', value: 'fab fa-algolia'},
    {id: 'fab fa-amazon', name: 'amazon', value: 'fab fa-amazon'},
    {id: 'fab fa-amazon-pay', name: 'amazon-pay', value: 'fab fa-amazon-pay'},
    {id: 'fab fa-amilia', name: 'amilia', value: 'fab fa-amilia'},
    {id: 'fab fa-android', name: 'android', value: 'fab fa-android'},
    {id: 'fab fa-angellist', name: 'angellist', value: 'fab fa-angellist'},
    {id: 'fab fa-angrycreative', name: 'angrycreative', value: 'fab fa-angrycreative'},
    {id: 'fab fa-angular', name: 'angular', value: 'fab fa-angular'},
    {id: 'fab fa-app-store', name: 'app-store', value: 'fab fa-app-store'},
    {id: 'fab fa-app-store-ios', name: 'app-store-ios', value: 'fab fa-app-store-ios'},
    {id: 'fab fa-apper', name: 'apper', value: 'fab fa-apper'},
    {id: 'fab fa-apple', name: 'apple', value: 'fab fa-apple'},
    {id: 'fab fa-apple-pay', name: 'apple-pay', value: 'fab fa-apple-pay'},
    {id: 'fab fa-asymmetrik', name: 'asymmetrik', value: 'fab fa-asymmetrik'},
    {id: 'fab fa-audible', name: 'audible', value: 'fab fa-audible'},
    {id: 'fab fa-autoprefixer', name: 'autoprefixer', value: 'fab fa-autoprefixer'},
    {id: 'fab fa-avianex', name: 'avianex', value: 'fab fa-avianex'},
    {id: 'fab fa-aviato', name: 'aviato', value: 'fab fa-aviato'},
    {id: 'fab fa-aws', name: 'aws', value: 'fab fa-aws'},
    {id: 'fab fa-bandcamp', name: 'bandcamp', value: 'fab fa-bandcamp'},
    {id: 'fab fa-behance', name: 'behance', value: 'fab fa-behance'},
    {id: 'fab fa-behance-square', name: 'behance-square', value: 'fab fa-behance-square'},
    {id: 'fab fa-bimobject', name: 'bimobject', value: 'fab fa-bimobject'},
    {id: 'fab fa-bitbucket', name: 'bitbucket', value: 'fab fa-bitbucket'},
    {id: 'fab fa-bitcoin', name: 'bitcoin', value: 'fab fa-bitcoin'},
    {id: 'fab fa-bity', name: 'bity', value: 'fab fa-bity'},
    {id: 'fab fa-black-tie', name: 'black-tie', value: 'fab fa-black-tie'},
    {id: 'fab fa-blackberry', name: 'blackberry', value: 'fab fa-blackberry'},
    {id: 'fab fa-blogger', name: 'blogger', value: 'fab fa-blogger'},
    {id: 'fab fa-blogger-b', name: 'blogger-b', value: 'fab fa-blogger-b'},
    {id: 'fab fa-bluetooth', name: 'bluetooth', value: 'fab fa-bluetooth'},
    {id: 'fab fa-bluetooth-b', name: 'bluetooth-b', value: 'fab fa-bluetooth-b'},
    {id: 'fab fa-btc', name: 'btc', value: 'fab fa-btc'},
    {id: 'fab fa-buromobelexperte', name: 'buromobelexperte', value: 'fab fa-buromobelexperte'},
    {id: 'fab fa-cc-amazon-pay', name: 'cc-amazon-pay', value: 'fab fa-cc-amazon-pay'},
    {id: 'fab fa-cc-amex', name: 'cc-amex', value: 'fab fa-cc-amex'},
    {id: 'fab fa-cc-apple-pay', name: 'cc-apple-pay', value: 'fab fa-cc-apple-pay'},
    {id: 'fab fa-cc-diners-club', name: 'cc-diners-club', value: 'fab fa-cc-diners-club'},
    {id: 'fab fa-cc-discover', name: 'cc-discover', value: 'fab fa-cc-discover'},
    {id: 'fab fa-cc-jcb', name: 'cc-jcb', value: 'fab fa-cc-jcb'},
    {id: 'fab fa-cc-mastercard', name: 'cc-mastercard', value: 'fab fa-cc-mastercard'},
    {id: 'fab fa-cc-paypal', name: 'cc-paypal', value: 'fab fa-cc-paypal'},
    {id: 'fab fa-cc-stripe', name: 'cc-stripe', value: 'fab fa-cc-stripe'},
    {id: 'fab fa-cc-visa', name: 'cc-visa', value: 'fab fa-cc-visa'},
    {id: 'fab fa-centercode', name: 'centercode', value: 'fab fa-centercode'},
    {id: 'fab fa-chrome', name: 'chrome', value: 'fab fa-chrome'},
    {id: 'fab fa-cloudscale', name: 'cloudscale', value: 'fab fa-cloudscale'},
    {id: 'fab fa-cloudsmith', name: 'cloudsmith', value: 'fab fa-cloudsmith'},
    {id: 'fab fa-cloudversify', name: 'cloudversify', value: 'fab fa-cloudversify'},
    {id: 'fab fa-codepen', name: 'codepen', value: 'fab fa-codepen'},
    {id: 'fab fa-codiepie', name: 'codiepie', value: 'fab fa-codiepie'},
    {id: 'fab fa-connectdevelop', name: 'connectdevelop', value: 'fab fa-connectdevelop'},
    {id: 'fab fa-contao', name: 'contao', value: 'fab fa-contao'},
    {id: 'fab fa-cpanel', name: 'cpanel', value: 'fab fa-cpanel'},
    {id: 'fab fa-creative-commons', name: 'creative-commons', value: 'fab fa-creative-commons'},
    {id: 'fab fa-css3', name: 'css3', value: 'fab fa-css3'},
    {id: 'fab fa-css3-alt', name: 'css3-alt', value: 'fab fa-css3-alt'},
    {id: 'fab fa-cuttlefish', name: 'cuttlefish', value: 'fab fa-cuttlefish'},
    {id: 'fab fa-d-and-d', name: 'd-and-d', value: 'fab fa-d-and-d'},
    {id: 'fab fa-dashcube', name: 'dashcube', value: 'fab fa-dashcube'},
    {id: 'fab fa-delicious', name: 'delicious', value: 'fab fa-delicious'},
    {id: 'fab fa-deploydog', name: 'deploydog', value: 'fab fa-deploydog'},
    {id: 'fab fa-deskpro', name: 'deskpro', value: 'fab fa-deskpro'},
    {id: 'fab fa-deviantart', name: 'deviantart', value: 'fab fa-deviantart'},
    {id: 'fab fa-digg', name: 'digg', value: 'fab fa-digg'},
    {id: 'fab fa-digital-ocean', name: 'digital-ocean', value: 'fab fa-digital-ocean'},
    {id: 'fab fa-discord', name: 'discord', value: 'fab fa-discord'},
    {id: 'fab fa-discourse', name: 'discourse', value: 'fab fa-discourse'},
    {id: 'fab fa-dochub', name: 'dochub', value: 'fab fa-dochub'},
    {id: 'fab fa-docker', name: 'docker', value: 'fab fa-docker'},
    {id: 'fab fa-draft2digital', name: 'draft2digital', value: 'fab fa-draft2digital'},
    {id: 'fab fa-dribbble', name: 'dribbble', value: 'fab fa-dribbble'},
    {id: 'fab fa-dribbble-square', name: 'dribbble-square', value: 'fab fa-dribbble-square'},
    {id: 'fab fa-dropbox', name: 'dropbox', value: 'fab fa-dropbox'},
    {id: 'fab fa-drupal', name: 'drupal', value: 'fab fa-drupal'},
    {id: 'fab fa-dyalog', name: 'dyalog', value: 'fab fa-dyalog'},
    {id: 'fab fa-earlybirds', name: 'earlybirds', value: 'fab fa-earlybirds'},
    {id: 'fab fa-edge', name: 'edge', value: 'fab fa-edge'},
    {id: 'fab fa-elementor', name: 'elementor', value: 'fab fa-elementor'},
    {id: 'fab fa-ember', name: 'ember', value: 'fab fa-ember'},
    {id: 'fab fa-empire', name: 'empire', value: 'fab fa-empire'},
    {id: 'fab fa-envira', name: 'envira', value: 'fab fa-envira'},
    {id: 'fab fa-erlang', name: 'erlang', value: 'fab fa-erlang'},
    {id: 'fab fa-ethereum', name: 'ethereum', value: 'fab fa-ethereum'},
    {id: 'fab fa-etsy', name: 'etsy', value: 'fab fa-etsy'},
    {id: 'fab fa-expeditedssl', name: 'expeditedssl', value: 'fab fa-expeditedssl'},
    {id: 'fab fa-facebook', name: 'facebook', value: 'fab fa-facebook'},
    {id: 'fab fa-facebook-f', name: 'facebook-f', value: 'fab fa-facebook-f'},
    {id: 'fab fa-facebook-messenger', name: 'facebook-messenger', value: 'fab fa-facebook-messenger'},
    {id: 'fab fa-facebook-square', name: 'facebook-square', value: 'fab fa-facebook-square'},
    {id: 'fab fa-firefox', name: 'firefox', value: 'fab fa-firefox'},
    {id: 'fab fa-first-order', name: 'first-order', value: 'fab fa-first-order'},
    {id: 'fab fa-firstdraft', name: 'firstdraft', value: 'fab fa-firstdraft'},
    {id: 'fab fa-flickr', name: 'flickr', value: 'fab fa-flickr'},
    {id: 'fab fa-flipboard', name: 'flipboard', value: 'fab fa-flipboard'},
    {id: 'fab fa-fly', name: 'fly', value: 'fab fa-fly'},
    {id: 'fab fa-font-awesome', name: 'font-awesome', value: 'fab fa-font-awesome'},
    {id: 'fab fa-font-awesome-alt', name: 'font-awesome-alt', value: 'fab fa-font-awesome-alt'},
    {id: 'fab fa-font-awesome-flag', name: 'font-awesome-flag', value: 'fab fa-font-awesome-flag'},
    {id: 'fab fa-fonticons', name: 'fonticons', value: 'fab fa-fonticons'},
    {id: 'fab fa-fonticons-fi', name: 'fonticons-fi', value: 'fab fa-fonticons-fi'},
    {id: 'fab fa-fort-awesome', name: 'fort-awesome', value: 'fab fa-fort-awesome'},
    {id: 'fab fa-fort-awesome-alt', name: 'fort-awesome-alt', value: 'fab fa-fort-awesome-alt'},
    {id: 'fab fa-forumbee', name: 'forumbee', value: 'fab fa-forumbee'},
    {id: 'fab fa-foursquare', name: 'foursquare', value: 'fab fa-foursquare'},
    {id: 'fab fa-free-code-camp', name: 'free-code-camp', value: 'fab fa-free-code-camp'},
    {id: 'fab fa-freebsd', name: 'freebsd', value: 'fab fa-freebsd'},
    {id: 'fab fa-get-pocket', name: 'get-pocket', value: 'fab fa-get-pocket'},
    {id: 'fab fa-gg', name: 'gg', value: 'fab fa-gg'},
    {id: 'fab fa-gg-circle', name: 'gg-circle', value: 'fab fa-gg-circle'},
    {id: 'fab fa-git', name: 'git', value: 'fab fa-git'},
    {id: 'fab fa-git-square', name: 'git-square', value: 'fab fa-git-square'},
    {id: 'fab fa-github', name: 'github', value: 'fab fa-github'},
    {id: 'fab fa-github-alt', name: 'github-alt', value: 'fab fa-github-alt'},
    {id: 'fab fa-github-square', name: 'github-square', value: 'fab fa-github-square'},
    {id: 'fab fa-gitkraken', name: 'gitkraken', value: 'fab fa-gitkraken'},
    {id: 'fab fa-gitlab', name: 'gitlab', value: 'fab fa-gitlab'},
    {id: 'fab fa-gitter', name: 'gitter', value: 'fab fa-gitter'},
    {id: 'fab fa-glide', name: 'glide', value: 'fab fa-glide'},
    {id: 'fab fa-glide-g', name: 'glide-g', value: 'fab fa-glide-g'},
    {id: 'fab fa-gofore', name: 'gofore', value: 'fab fa-gofore'},
    {id: 'fab fa-goodreads', name: 'goodreads', value: 'fab fa-goodreads'},
    {id: 'fab fa-goodreads-g', name: 'goodreads-g', value: 'fab fa-goodreads-g'},
    {id: 'fab fa-google', name: 'google', value: 'fab fa-google'},
    {id: 'fab fa-google-drive', name: 'google-drive', value: 'fab fa-google-drive'},
    {id: 'fab fa-google-play', name: 'google-play', value: 'fab fa-google-play'},
    {id: 'fab fa-google-plus', name: 'google-plus', value: 'fab fa-google-plus'},
    {id: 'fab fa-google-plus-g', name: 'google-plus-g', value: 'fab fa-google-plus-g'},
    {id: 'fab fa-google-plus-square', name: 'google-plus-square', value: 'fab fa-google-plus-square'},
    {id: 'fab fa-google-wallet', name: 'google-wallet', value: 'fab fa-google-wallet'},
    {id: 'fab fa-gratipay', name: 'gratipay', value: 'fab fa-gratipay'},
    {id: 'fab fa-grav', name: 'grav', value: 'fab fa-grav'},
    {id: 'fab fa-gripfire', name: 'gripfire', value: 'fab fa-gripfire'},
    {id: 'fab fa-grunt', name: 'grunt', value: 'fab fa-grunt'},
    {id: 'fab fa-gulp', name: 'gulp', value: 'fab fa-gulp'},
    {id: 'fab fa-hacker-news', name: 'hacker-news', value: 'fab fa-hacker-news'},
    {id: 'fab fa-hacker-news-square', name: 'hacker-news-square', value: 'fab fa-hacker-news-square'},
    {id: 'fab fa-hips', name: 'hips', value: 'fab fa-hips'},
    {id: 'fab fa-hire-a-helper', name: 'hire-a-helper', value: 'fab fa-hire-a-helper'},
    {id: 'fab fa-hooli', name: 'hooli', value: 'fab fa-hooli'},
    {id: 'fab fa-hotjar', name: 'hotjar', value: 'fab fa-hotjar'},
    {id: 'fab fa-houzz', name: 'houzz', value: 'fab fa-houzz'},
    {id: 'fab fa-html5', name: 'html5', value: 'fab fa-html5'},
    {id: 'fab fa-hubspot', name: 'hubspot', value: 'fab fa-hubspot'},
    {id: 'fab fa-imdb', name: 'imdb', value: 'fab fa-imdb'},
    {id: 'fab fa-instagram', name: 'instagram', value: 'fab fa-instagram'},
    {id: 'fab fa-internet-explorer', name: 'internet-explorer', value: 'fab fa-internet-explorer'},
    {id: 'fab fa-ioxhost', name: 'ioxhost', value: 'fab fa-ioxhost'},
    {id: 'fab fa-itunes', name: 'itunes', value: 'fab fa-itunes'},
    {id: 'fab fa-itunes-note', name: 'itunes-note', value: 'fab fa-itunes-note'},
    {id: 'fab fa-jenkins', name: 'jenkins', value: 'fab fa-jenkins'},
    {id: 'fab fa-joget', name: 'joget', value: 'fab fa-joget'},
    {id: 'fab fa-joomla', name: 'joomla', value: 'fab fa-joomla'},
    {id: 'fab fa-js', name: 'js', value: 'fab fa-js'},
    {id: 'fab fa-js-square', name: 'js-square', value: 'fab fa-js-square'},
    {id: 'fab fa-jsfiddle', name: 'jsfiddle', value: 'fab fa-jsfiddle'},
    {id: 'fab fa-keycdn', name: 'keycdn', value: 'fab fa-keycdn'},
    {id: 'fab fa-kickstarter', name: 'kickstarter', value: 'fab fa-kickstarter'},
    {id: 'fab fa-kickstarter-k', name: 'kickstarter-k', value: 'fab fa-kickstarter-k'},
    {id: 'fab fa-korvue', name: 'korvue', value: 'fab fa-korvue'},
    {id: 'fab fa-laravel', name: 'laravel', value: 'fab fa-laravel'},
    {id: 'fab fa-lastfm', name: 'lastfm', value: 'fab fa-lastfm'},
    {id: 'fab fa-lastfm-square', name: 'lastfm-square', value: 'fab fa-lastfm-square'},
    {id: 'fab fa-leanpub', name: 'leanpub', value: 'fab fa-leanpub'},
    {id: 'fab fa-less', name: 'less', value: 'fab fa-less'},
    {id: 'fab fa-line', name: 'line', value: 'fab fa-line'},
    {id: 'fab fa-linkedin', name: 'linkedin', value: 'fab fa-linkedin'},
    {id: 'fab fa-linkedin-in', name: 'linkedin-in', value: 'fab fa-linkedin-in'},
    {id: 'fab fa-linode', name: 'linode', value: 'fab fa-linode'},
    {id: 'fab fa-linux', name: 'linux', value: 'fab fa-linux'},
    {id: 'fab fa-lyft', name: 'lyft', value: 'fab fa-lyft'},
    {id: 'fab fa-magento', name: 'magento', value: 'fab fa-magento'},
    {id: 'fab fa-maxcdn', name: 'maxcdn', value: 'fab fa-maxcdn'},
    {id: 'fab fa-medapps', name: 'medapps', value: 'fab fa-medapps'},
    {id: 'fab fa-medium', name: 'medium', value: 'fab fa-medium'},
    {id: 'fab fa-medium-m', name: 'medium-m', value: 'fab fa-medium-m'},
    {id: 'fab fa-medrt', name: 'medrt', value: 'fab fa-medrt'},
    {id: 'fab fa-meetup', name: 'meetup', value: 'fab fa-meetup'},
    {id: 'fab fa-microsoft', name: 'microsoft', value: 'fab fa-microsoft'},
    {id: 'fab fa-mix', name: 'mix', value: 'fab fa-mix'},
    {id: 'fab fa-mixcloud', name: 'mixcloud', value: 'fab fa-mixcloud'},
    {id: 'fab fa-mizuni', name: 'mizuni', value: 'fab fa-mizuni'},
    {id: 'fab fa-modx', name: 'modx', value: 'fab fa-modx'},
    {id: 'fab fa-monero', name: 'monero', value: 'fab fa-monero'},
    {id: 'fab fa-napster', name: 'napster', value: 'fab fa-napster'},
    {id: 'fab fa-nintendo-switch', name: 'nintendo-switch', value: 'fab fa-nintendo-switch'},
    {id: 'fab fa-node', name: 'node', value: 'fab fa-node'},
    {id: 'fab fa-node-js', name: 'node-js', value: 'fab fa-node-js'},
    {id: 'fab fa-npm', name: 'npm', value: 'fab fa-npm'},
    {id: 'fab fa-ns8', name: 'ns8', value: 'fab fa-ns8'},
    {id: 'fab fa-nutritionix', name: 'nutritionix', value: 'fab fa-nutritionix'},
    {id: 'fab fa-odnoklassniki', name: 'odnoklassniki', value: 'fab fa-odnoklassniki'},
    {id: 'fab fa-odnoklassniki-square', name: 'odnoklassniki-square', value: 'fab fa-odnoklassniki-square'},
    {id: 'fab fa-opencart', name: 'opencart', value: 'fab fa-opencart'},
    {id: 'fab fa-openid', name: 'openid', value: 'fab fa-openid'},
    {id: 'fab fa-opera', name: 'opera', value: 'fab fa-opera'},
    {id: 'fab fa-optin-monster', name: 'optin-monster', value: 'fab fa-optin-monster'},
    {id: 'fab fa-osi', name: 'osi', value: 'fab fa-osi'},
    {id: 'fab fa-page4', name: 'page4', value: 'fab fa-page4'},
    {id: 'fab fa-pagelines', name: 'pagelines', value: 'fab fa-pagelines'},
    {id: 'fab fa-palfed', name: 'palfed', value: 'fab fa-palfed'},
    {id: 'fab fa-patreon', name: 'patreon', value: 'fab fa-patreon'},
    {id: 'fab fa-paypal', name: 'paypal', value: 'fab fa-paypal'},
    {id: 'fab fa-periscope', name: 'periscope', value: 'fab fa-periscope'},
    {id: 'fab fa-phabricator', name: 'phabricator', value: 'fab fa-phabricator'},
    {id: 'fab fa-phoenix-framework', name: 'phoenix-framework', value: 'fab fa-phoenix-framework'},
    {id: 'fab fa-php', name: 'php', value: 'fab fa-php'},
    {id: 'fab fa-pied-piper', name: 'pied-piper', value: 'fab fa-pied-piper'},
    {id: 'fab fa-pied-piper-alt', name: 'pied-piper-alt', value: 'fab fa-pied-piper-alt'},
    {id: 'fab fa-pied-piper-pp', name: 'pied-piper-pp', value: 'fab fa-pied-piper-pp'},
    {id: 'fab fa-pinterest', name: 'pinterest', value: 'fab fa-pinterest'},
    {id: 'fab fa-pinterest-p', name: 'pinterest-p', value: 'fab fa-pinterest-p'},
    {id: 'fab fa-pinterest-square', name: 'pinterest-square', value: 'fab fa-pinterest-square'},
    {id: 'fab fa-playstation', name: 'playstation', value: 'fab fa-playstation'},
    {id: 'fab fa-product-hunt', name: 'product-hunt', value: 'fab fa-product-hunt'},
    {id: 'fab fa-pushed', name: 'pushed', value: 'fab fa-pushed'},
    {id: 'fab fa-python', name: 'python', value: 'fab fa-python'},
    {id: 'fab fa-qq', name: 'qq', value: 'fab fa-qq'},
    {id: 'fab fa-quinscape', name: 'quinscape', value: 'fab fa-quinscape'},
    {id: 'fab fa-quora', name: 'quora', value: 'fab fa-quora'},
    {id: 'fab fa-ravelry', name: 'ravelry', value: 'fab fa-ravelry'},
    {id: 'fab fa-react', name: 'react', value: 'fab fa-react'},
    {id: 'fab fa-readme', name: 'readme', value: 'fab fa-readme'},
    {id: 'fab fa-rebel', name: 'rebel', value: 'fab fa-rebel'},
    {id: 'fab fa-red-river', name: 'red-river', value: 'fab fa-red-river'},
    {id: 'fab fa-reddit', name: 'reddit', value: 'fab fa-reddit'},
    {id: 'fab fa-reddit-alien', name: 'reddit-alien', value: 'fab fa-reddit-alien'},
    {id: 'fab fa-reddit-square', name: 'reddit-square', value: 'fab fa-reddit-square'},
    {id: 'fab fa-rendact', name: 'rendact', value: 'fab fa-rendact'},
    {id: 'fab fa-renren', name: 'renren', value: 'fab fa-renren'},
    {id: 'fab fa-replyd', name: 'replyd', value: 'fab fa-replyd'},
    {id: 'fab fa-resolving', name: 'resolving', value: 'fab fa-resolving'},
    {id: 'fab fa-rocketchat', name: 'rocketchat', value: 'fab fa-rocketchat'},
    {id: 'fab fa-rockrms', name: 'rockrms', value: 'fab fa-rockrms'},
    {id: 'fab fa-safari', name: 'safari', value: 'fab fa-safari'},
    {id: 'fab fa-sass', name: 'sass', value: 'fab fa-sass'},
    {id: 'fab fa-schlix', name: 'schlix', value: 'fab fa-schlix'},
    {id: 'fab fa-scribd', name: 'scribd', value: 'fab fa-scribd'},
    {id: 'fab fa-searchengin', name: 'searchengin', value: 'fab fa-searchengin'},
    {id: 'fab fa-sellcast', name: 'sellcast', value: 'fab fa-sellcast'},
    {id: 'fab fa-sellsy', name: 'sellsy', value: 'fab fa-sellsy'},
    {id: 'fab fa-servicestack', name: 'servicestack', value: 'fab fa-servicestack'},
    {id: 'fab fa-shirtsinbulk', name: 'shirtsinbulk', value: 'fab fa-shirtsinbulk'},
    {id: 'fab fa-simplybuilt', name: 'simplybuilt', value: 'fab fa-simplybuilt'},
    {id: 'fab fa-sistrix', name: 'sistrix', value: 'fab fa-sistrix'},
    {id: 'fab fa-skyatlas', name: 'skyatlas', value: 'fab fa-skyatlas'},
    {id: 'fab fa-skype', name: 'skype', value: 'fab fa-skype'},
    {id: 'fab fa-slack', name: 'slack', value: 'fab fa-slack'},
    {id: 'fab fa-slack-hash', name: 'slack-hash', value: 'fab fa-slack-hash'},
    {id: 'fab fa-slideshare', name: 'slideshare', value: 'fab fa-slideshare'},
    {id: 'fab fa-snapchat', name: 'snapchat', value: 'fab fa-snapchat'},
    {id: 'fab fa-snapchat-ghost', name: 'snapchat-ghost', value: 'fab fa-snapchat-ghost'},
    {id: 'fab fa-snapchat-square', name: 'snapchat-square', value: 'fab fa-snapchat-square'},
    {id: 'fab fa-soundcloud', name: 'soundcloud', value: 'fab fa-soundcloud'},
    {id: 'fab fa-speakap', name: 'speakap', value: 'fab fa-speakap'},
    {id: 'fab fa-spotify', name: 'spotify', value: 'fab fa-spotify'},
    {id: 'fab fa-stack-exchange', name: 'stack-exchange', value: 'fab fa-stack-exchange'},
    {id: 'fab fa-stack-overflow', name: 'stack-overflow', value: 'fab fa-stack-overflow'},
    {id: 'fab fa-staylinked', name: 'staylinked', value: 'fab fa-staylinked'},
    {id: 'fab fa-steam', name: 'steam', value: 'fab fa-steam'},
    {id: 'fab fa-steam-square', name: 'steam-square', value: 'fab fa-steam-square'},
    {id: 'fab fa-steam-symbol', name: 'steam-symbol', value: 'fab fa-steam-symbol'},
    {id: 'fab fa-sticker-mule', name: 'sticker-mule', value: 'fab fa-sticker-mule'},
    {id: 'fab fa-strava', name: 'strava', value: 'fab fa-strava'},
    {id: 'fab fa-stripe', name: 'stripe', value: 'fab fa-stripe'},
    {id: 'fab fa-stripe-s', name: 'stripe-s', value: 'fab fa-stripe-s'},
    {id: 'fab fa-studiovinari', name: 'studiovinari', value: 'fab fa-studiovinari'},
    {id: 'fab fa-stumbleupon', name: 'stumbleupon', value: 'fab fa-stumbleupon'},
    {id: 'fab fa-stumbleupon-circle', name: 'stumbleupon-circle', value: 'fab fa-stumbleupon-circle'},
    {id: 'fab fa-superpowers', name: 'superpowers', value: 'fab fa-superpowers'},
    {id: 'fab fa-supple', name: 'supple', value: 'fab fa-supple'},
    {id: 'fab fa-telegram', name: 'telegram', value: 'fab fa-telegram'},
    {id: 'fab fa-telegram-plane', name: 'telegram-plane', value: 'fab fa-telegram-plane'},
    {id: 'fab fa-tencent-weibo', name: 'tencent-weibo', value: 'fab fa-tencent-weibo'},
    {id: 'fab fa-themeisle', name: 'themeisle', value: 'fab fa-themeisle'},
    {id: 'fab fa-trello', name: 'trello', value: 'fab fa-trello'},
    {id: 'fab fa-tripadvisor', name: 'tripadvisor', value: 'fab fa-tripadvisor'},
    {id: 'fab fa-tumblr', name: 'tumblr', value: 'fab fa-tumblr'},
    {id: 'fab fa-tumblr-square', name: 'tumblr-square', value: 'fab fa-tumblr-square'},
    {id: 'fab fa-twitch', name: 'twitch', value: 'fab fa-twitch'},
    {id: 'fab fa-twitter', name: 'twitter', value: 'fab fa-twitter'},
    {id: 'fab fa-twitter-square', name: 'twitter-square', value: 'fab fa-twitter-square'},
    {id: 'fab fa-typo3', name: 'typo3', value: 'fab fa-typo3'},
    {id: 'fab fa-uber', name: 'uber', value: 'fab fa-uber'},
    {id: 'fab fa-uikit', name: 'uikit', value: 'fab fa-uikit'},
    {id: 'fab fa-uniregistry', name: 'uniregistry', value: 'fab fa-uniregistry'},
    {id: 'fab fa-untappd', name: 'untappd', value: 'fab fa-untappd'},
    {id: 'fab fa-usb', name: 'usb', value: 'fab fa-usb'},
    {id: 'fab fa-ussunnah', name: 'ussunnah', value: 'fab fa-ussunnah'},
    {id: 'fab fa-vaadin', name: 'vaadin', value: 'fab fa-vaadin'},
    {id: 'fab fa-viacoin', name: 'viacoin', value: 'fab fa-viacoin'},
    {id: 'fab fa-viadeo', name: 'viadeo', value: 'fab fa-viadeo'},
    {id: 'fab fa-viber', name: 'viber', value: 'fab fa-viber'},
    {id: 'fab fa-vimeo', name: 'vimeo', value: 'fab fa-vimeo'},
    {id: 'fab fa-vimeo-square', name: 'vimeo-square', value: 'fab fa-vimeo-square'},
    {id: 'fab fa-vimeo-v', name: 'vimeo-v', value: 'fab fa-vimeo-v'},
    {id: 'fab fa-vine', name: 'vine', value: 'fab fa-vine'},
    {id: 'fab fa-vk', name: 'vk', value: 'fab fa-vk'},
    {id: 'fab fa-vnv', name: 'vnv', value: 'fab fa-vnv'},
    {id: 'fab fa-vuejs', name: 'vuejs', value: 'fab fa-vuejs'},
    {id: 'fab fa-weibo', name: 'weibo', value: 'fab fa-weibo'},
    {id: 'fab fa-weixin', name: 'weixin', value: 'fab fa-weixin'},
    {id: 'fab fa-whatsapp', name: 'whatsapp', value: 'fab fa-whatsapp'},
    {id: 'fab fa-whatsapp-square', name: 'whatsapp-square', value: 'fab fa-whatsapp-square'},
    {id: 'fab fa-whmcs', name: 'whmcs', value: 'fab fa-whmcs'},
    {id: 'fab fa-wikipedia-w', name: 'wikipedia-w', value: 'fab fa-wikipedia-w'},
    {id: 'fab fa-windows', name: 'windows', value: 'fab fa-windows'},
    {id: 'fab fa-wordpress', name: 'wordpress', value: 'fab fa-wordpress'},
    {id: 'fab fa-wordpress-simple', name: 'wordpress-simple', value: 'fab fa-wordpress-simple'},
    {id: 'fab fa-wpbeginner', name: 'wpbeginner', value: 'fab fa-wpbeginner'},
    {id: 'fab fa-wpexplorer', name: 'wpexplorer', value: 'fab fa-wpexplorer'},
    {id: 'fab fa-wpforms', name: 'wpforms', value: 'fab fa-wpforms'},
    {id: 'fab fa-xbox', name: 'xbox', value: 'fab fa-xbox'},
    {id: 'fab fa-xing', name: 'xing', value: 'fab fa-xing'},
    {id: 'fab fa-xing-square', name: 'xing-square', value: 'fab fa-xing-square'},
    {id: 'fab fa-y-combinator', name: 'y-combinator', value: 'fab fa-y-combinator'},
    {id: 'fab fa-yahoo', name: 'yahoo', value: 'fab fa-yahoo'},
    {id: 'fab fa-yandex', name: 'yandex', value: 'fab fa-yandex'},
    {id: 'fab fa-yandex-international', name: 'yandex-international', value: 'fab fa-yandex-international'},
    {id: 'fab fa-yelp', name: 'yelp', value: 'fab fa-yelp'},
    {id: 'fab fa-yoast', name: 'yoast', value: 'fab fa-yoast'},
    {id: 'fab fa-youtube', name: 'youtube', value: 'fab fa-youtube'},
    {id: 'fab fa-youtube-square', name: 'youtube-square', value: 'fab fa-youtube-square'},
]